<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
        <TitleTextContent
          :titleText="'Page Not Found'"
        />
        <router-link 
          :to="{
            name: 'index',
          }"
        >
          <v-btn
            rounded
            large
            dark
            :color="'#424EC4'"
            width="140"
          >
            Home
          </v-btn>
        </router-link>
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->

    <!-- BradCrumb header End -->
    <!-- 404 Area Start-->
    <section class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-8">
            <img src="assets/images/404.jpg" alt="" class="img-fluid w-100" />
            <div class="mt-4 text-center">
              <h2 class="title">The page you're looking for does not exist</h2>
              <b-button
                pill
                variant="outline-light"
                class="outline-theme-btn"
                @click="$router.push('/')"
                >Back to Homepage</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 404 Area End-->
  </div>
</template>
<script>
import PageHeader from "./library/widgets/page-header.vue";
import PageHeaderTitleContent from "./library/widgets/page-header-title-content.vue";
import TitleTextContent from "./library/widgets/title-text-content.vue";
export default {
  name: 'error',
  components: {
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();
    },
    initFooterHeight() {
      var footerHeight = $('footer').outerHeight();
      $('.main-content').css('margin-bottom', footerHeight);
    },
  },
};
</script>
